import React, { useState } from 'react';
import { getProviderIconPath } from '../../utils/providerIcons';

/**
 * Logos opérateurs = carrés pleine couleur : on les remplit (object-cover) dans une tuile arrondie.
 * M-Pesa et Pay ont beaucoup de marge autour du logo : on zoome pour recadrer sur la marque.
 */
const zoomFor = (src) => {
    if (/M-pesa\.png$/i.test(src)) return 1.7;
    if (/\/pay\.png$/i.test(src)) return 1.5;
    return 1;
};

/** Logo sur fond blanc et plus large que haut (Visa) : affiché en entier, sans recadrage. */
const isContained = (src) => /visa\.png$/i.test(src);

const initials = (name) =>
    String(name || '?').split(/\s+/).filter(Boolean).map((w) => w[0]).join('').slice(0, 2).toUpperCase();

const ProviderLogo = ({ provider, className = 'w-12 h-12 rounded-xl' }) => {
    const [failed, setFailed] = useState(false);
    const src = getProviderIconPath(provider?.id, provider?.name);

    return (
        <span className={`relative block overflow-hidden shrink-0 bg-slate-100 ${className}`}>
            {failed || !src ? (
                <span className="absolute inset-0 flex items-center justify-center text-xs font-bold text-slate-500">
                    {initials(provider?.name)}
                </span>
            ) : (
                <img
                    src={src}
                    alt={provider?.name || ''}
                    className={`absolute inset-0 w-full h-full ${isContained(src) ? 'object-contain bg-white p-0.5' : 'object-cover'}`}
                    style={isContained(src) ? undefined : { transform: `scale(${zoomFor(src)})` }}
                    loading="eager"
                    onError={() => setFailed(true)}
                />
            )}
        </span>
    );
};

export default ProviderLogo;
